export type RuntimeConfig = {
  apiBaseUrl: string
  supabaseUrl: string
  supabaseAnonKey: string
  gtmEnabled: boolean
  gtmKey: string
  buildVersion: string
}

declare global {
  interface Window {
    __DASH_RUNTIME_CONFIG__?: Partial<RuntimeConfig>
  }
}

const truthy = (value: unknown) => value === true || value === 'true' || value === '1'

export const getRuntimeConfig = (): RuntimeConfig => {
  const runtime = window.__DASH_RUNTIME_CONFIG__ ?? {}

  return {
    apiBaseUrl: runtime.apiBaseUrl ?? import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
    supabaseUrl: runtime.supabaseUrl ?? import.meta.env.VITE_SUPABASE_URL ?? '',
    supabaseAnonKey: runtime.supabaseAnonKey ?? import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
    gtmEnabled: runtime.gtmEnabled ?? truthy(import.meta.env.VITE_APP_GTM_ENABLED),
    gtmKey: runtime.gtmKey ?? import.meta.env.VITE_APP_GTM_KEY ?? '',
    buildVersion: runtime.buildVersion ?? import.meta.env.VITE_APP_BUILD_VERSION ?? '',
  }
}
